export const sizes = { sidebarWidth: 200 } as const;
